// components/Logo.jsx
export default function Logo({ className = "" }) {
  return (
    <div className={`flex justify-center mb-4 ${className}`}>
      <img
        src="/images/logo.png"
        alt="لوگو شرکت"
        className="w-[100px] h-[100px] object-contain"
      />
    </div>
  );
}